// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 11) return "static/js/98d55f4faf3f3065b105.bundle.js";
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"41":"431fa5e49a23b4510e74","180":"5a47398edde3c3cd7288","181":"96dae261e3f73ab3de0b"}[chunkId] + ".chunk.js";
};